import {
  FETCH_USER,
  FETCH_USER_FAILED,
  FETCH_USER_SUCCESS
} from '../../types';

const initialState = {
  profile: {},
  isAuth: false,
  isLoading: false,
  errors: {},
  error: false
}


const fetchUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER:
      return {
        ...state,
        isLoading: true,
          isAuth: false,
          profile: action.payload
      }
      case FETCH_USER_SUCCESS:
        return {
          ...state,
          isLoading: false,
            isAuth: true,
            profile: action.payload
        }
        case FETCH_USER_FAILED:
          return {
            ...state,
            isLoading: false,
              isAuth: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchUserReducer;
